export default {
  roles: [],
};
